import { useAuth } from "@/auth/Auth";
import { integrationFieldPresets } from "@/components/shared/IntegrationTable/integrationFieldPresets";
import IntegrationTable from "@/components/shared/IntegrationTable/IntegrationTable";
import { useTranslation } from "react-i18next";
import MundTb3 from "../icons/MundTb3";
import Tb3Icon from "../icons/Tb3";

export default function Tb3() {
  const { t } = useTranslation("common");
 const { authData } = useAuth();

  return (
    <IntegrationTable
      integrationKey="tb3"
      title="Tb3"
      main_icon={<MundTb3 />}
      icon={<Tb3Icon />}
      fields={[
        integrationFieldPresets.access_token,
        integrationFieldPresets.status,
      ]}
      fixedValues={
        {
          payment_methods: authData?.available_payment_methods?.map(m => m.type),
          active_statuses: ['paid', 'refunded', 'chargeback']
        }
      }
      fieldLabels={{
        access_token: t("label_api_key"),
        placeholder_access_token: t("placeholder_api_key"),
      }}
    />
  );
}
